import React from "react";
import "../Css/groovePQR_pdf.css";
import Groove_pdf_headerPQR from "./Groove_pdf_headerPQR";
import Wld_Consolelog from "../../../utility/common/helpers/ConsoleLog";
import { 
  PQRBaseMetalTable, 
  PQRFillerMetalTable, 
  PQRPostWeldHeatTable,
  PQRJointTable,
  PQRWeldingProcessTable,
  PQRPositionTable,
  PQRPreheatTable,
  PQRGasTable,
  PQRElectricalTable,
  PQRTechniqueTable
} from "./common";

const Groove_pdf_page1PQR = ({ pdf, PQRtype, previewUrl1, previewUrl2 }) => {
  Wld_Consolelog("PQRtypeeeeeeew", PQRtype);
  Wld_Consolelog("dpdpd", pdf);
  
  const isoverlay = pdf[0]?.wld_WPSType === "Groove" ? false : true;
  const weldingType = isoverlay ? "Overlay" : "Groove";
  
  Wld_Consolelog("typeeee", pdf[0]?.wld_WPSType, isoverlay);

  return (
    <div className="MainPDF">
      <Groove_pdf_headerPQR pdf={pdf} />
      
      <PQRBaseMetalTable pdf={pdf} type={weldingType} previewUrl1={previewUrl1} previewUrl2={previewUrl2} />
      <PQRPostWeldHeatTable pdf={pdf} />
     <PQRJointTable pdf={pdf} type={weldingType} previewUrl1={previewUrl1} previewUrl2={previewUrl2} />
      <PQRWeldingProcessTable pdf={pdf} type={weldingType} />
      <PQRFillerMetalTable pdf={pdf} type={weldingType} />
      <PQRPositionTable pdf={pdf} />
      <PQRPreheatTable pdf={pdf} />
      <PQRGasTable pdf={pdf} type={weldingType} />
      <PQRElectricalTable pdf={pdf} type={weldingType} />
      <PQRTechniqueTable pdf={pdf} type={weldingType} />

      <div className="WPSfooter" style={{ position: "fixed", top: "1015px", fontFamily: pdf[4] ? "GE-BodyCopy" : "inherit" }}>
        <table className="WPSfooter">
          <tr><td>Page 1 of {pdf[4] ? "3" : "2"}</td></tr>
        </table>
      </div>
    </div>
  );
};

export default Groove_pdf_page1PQR;